var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.798 7.963h-.848a.318.318 0 00-.317.318v3.864a.372.372 0 01-.372.372H3.855a.372.372 0 01-.372-.372V4.739c0-.205.167-.372.372-.372h4.062a.318.318 0 00.318-.317v-.848a.318.318 0 00-.318-.318H3.855A1.857 1.857 0 002 4.74v7.406C2 13.168 2.832 14 3.855 14h7.406a1.857 1.857 0 001.855-1.855V8.28a.318.318 0 00-.318-.318z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.682 2h-3.37a.318.318 0 00-.319.318v.847c0 .176.143.318.318.318h1.157L7.114 7.837a.318.318 0 000 .45l.6.599a.318.318 0 00.449 0l4.354-4.354v1.157c0 .175.142.318.318.318h.847A.318.318 0 0014 5.689V2.318A.318.318 0 0013.682 2z",
    fill: "#262626"
  })));
}

export default __webpack_public_path__ + "./fonts/open-link-icon.9fa0ed395311ea1ebd1567881ccbd8c1.svg";
export { SvgOpenLinkIcon as ReactComponent };